export default ({ jobmail: { activateError: jobmailActivateError } = {} } = {}) => jobmailActivateError
